@for (fieldId of fieldGroups.textInputs; track fieldId) {
  <ziro-text [fieldId]="fieldId"></ziro-text>
}

@for (fieldId of fieldGroups.multiTextInputs; track fieldId) {
  <ziro-multi-text [fieldId]="fieldId"></ziro-multi-text>
}

<div class="text-end">
  <ziro-submit-button
    [isPending]="isSubmitting"
    [isDisabled]="isSubmitting"
    [label]="'tkey;certificate_management.generate_csr.text'"
    [dataAutomation]="'admin-generate-csr-button'"
    [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
    [iconPending]="ziroIcons.SAVING"
    [formSubmitSubject]="_validateAndSubmitSource"
  ></ziro-submit-button>
</div>
